import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const WEIGHT_ROUTINES: Partial<Routine>[] = [
  {
    id: "weekly-meal-preparation",
    title: "Weekly Meal Preparation",
    symbol: "🍽️",
    description: "Set yourself up for nutritional success with planned meals",
    dailyRoutine: false,
    selectedDays: [{ day: "sunday", datetime: "14:00:00.000Z" }],
    color: RoutineColors[6].value,
    steps: [
      {
        id: "weight-mealprep-1",
        title: "Plan balanced meals",
        description: "Design meals with proper portions of protein, vegetables, and whole grains",
      },
      {
        id: "weight-mealprep-2",
        title: "Grocery shopping",
        description: "Purchase fresh ingredients focusing on whole, unprocessed foods",
      },
      {
        id: "weight-mealprep-3",
        title: "Batch cooking",
        description: "Prepare several meals in advance to have healthy options readily available",
      },
    ],
  },
  {
    id: "portion-awareness-practice",
    title: "Portion Awareness Practice",
    symbol: "🍽️",
    description: "Develop better awareness of appropriate portion sizes",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[7].value,
    steps: [
      {
        id: "weight-portion-1",
        title: "Pre-meal pause",
        description: "Take a moment to assess your hunger level before eating",
      },
      {
        id: "weight-portion-2",
        title: "Mindful plating",
        description:
          "Use smaller plates and fill half with vegetables, quarter with protein, quarter with grains",
      },
      {
        id: "weight-portion-3",
        title: "Eat slowly",
        description:
          "Take at least 20 minutes to eat your meal, putting utensils down between bites",
      },
    ],
  },
  {
    id: "active-lifestyle-integration",
    title: "Active Lifestyle Integration",
    symbol: "🏃",
    description: "Incorporate more movement into your everyday activities",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[8].value,
    steps: [
      {
        id: "weight-active-1",
        title: "Morning movement",
        description: "Start your day with 10 minutes of gentle stretching or brisk walking",
      },
      {
        id: "weight-active-2",
        title: "Active transportation",
        description: "Park farther away, take stairs, or walk/bike for short trips",
      },
      {
        id: "weight-active-3",
        title: "Movement breaks",
        description: "Take a 5-minute activity break for every hour of sitting",
      },
    ],
  },
];
